module.exports = __webpack_public_path__ + "img/fc61657.jpg";